<template>
  <div class="text-center fix-width-m-auto" id="cfs-retirement-calculator">
    <div id="ret-calc-ud-container" v-if="!displaySummary" class="p-8 bg-white">
      <retirement-calculator-user-data @click="validateAndSave" />
    </div>
    <retirement-calculator-summary v-else @click="validateAndSave" />
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import RetirementCalculatorUserData from '@/components/CFS/RetirementCalculatorComponents/RetirementCalculatorUserData.vue'
import RetirementCalculatorSummary from '@/components/CFS/RetirementCalculatorComponents/RetirementCalculatorSummary.vue'
import { useRetirementCalculatorStore } from '@/store/pinia/RetirementCalculatorStore'
import { useToast } from '@/composables/useToast'

// Store setup
const store = useStore()
const retirementCalculatorStore = useRetirementCalculatorStore()
const { errorToast } = useToast()

// Computed properties
const displaySummary = computed(() => retirementCalculatorStore.getDisplaySummary)
const disclaimer = computed(() => retirementCalculatorStore.getDisclaimer)

// Methods
const validateAndSave = async (): Promise<void> => {
  try {
    const success = await retirementCalculatorStore.validateAndCalculate()
    if (!success) {
      errorToast('Please check your inputs and try again.')
    }
  } catch (error) {
    console.error('Error during retirement calculation:', error)
    errorToast('An unexpected error occurred. Please try again later.')
  }
}

// Lifecycle
onMounted(async (): Promise<void> => {
  try {
    // Ensure label content is loaded specifically for retirement calculator
    await store.dispatch('fetchLabelContent', ['ret_calc'])

    // Super guarantee data is now auto-loaded in SuperStore, no need to fetch separately
    retirementCalculatorStore.createLocalStorage()

    await retirementCalculatorStore.fetchPreservationAgesForRetCalc()

    // Initialize contribution rates if not already set
    if (!retirementCalculatorStore.getUserData.contribution_rate) {
      await retirementCalculatorStore.setMinContributionRates()
    }

  } catch (error) {
    console.error('Error during retirement calculator initialization:', error)
    // Add user-friendly error handling
    console.warn('Some features may not work properly due to initialization errors')
  }
})
</script>

<style scoped >
@import '@/assets/css/themes/cfs/calculator.css';
</style>
